import cx from "classnames";
import React, { CSSProperties } from "react";
import styles from "./empty.module.scss";

export interface IEmpty {
  title?: React.ReactNode;
  description?: React.ReactNode;
  actions?: React.ReactNode;
  className?: string;
  style?: CSSProperties;
  htmlId?: string;
}

export const Empty = (props: IEmpty) => {
  return (
    <div className={cx(styles.empty, props.className)} style={props.style} id={props.htmlId}>
      {(props.title || props.description) && (
        <div className={styles.body}>
          {props.title && <div className={styles.title}>{props.title}</div>}
          {props.description && <div className={styles.description}>{props.description}</div>}
        </div>
      )}
      {props.actions && <div className={styles.actions}>{props.actions}</div>}
    </div>
  );
};

Empty.defaultProps = {};
